import React, {useState} from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";
import RefundStatusEnumComponent from "@/components/EnumComponents/RefundStatusEnumComponent";
import {Button, Select} from "antd";
import {formatDateFull} from "@/lib/utils/date";
import TableSearch from "@/components/table/tableSearch";
import {refundApi, useApiPostAdminRefundExcel} from "@/api/refund";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {FileExcelOutlined} from "@ant-design/icons";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import RenderIf from "@/components/render-if";


function RefundItemsListComponent({refundGroupId = null}) {

    const [needRefetch, setNeedRefetch] = useState(false)
    const [status, setStatus] = useState('')

    const {mutate: exportExcel, isPending: isPendingExport} = useApiPostAdminRefundExcel()

    function handleExportExcel() {
        exportExcel({
            status: status,
            refund_group_id: refundGroupId,
        }, {
            onSuccess: (response) => {

                const file = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = 'refunds.xlsx';
                link.click();

                link.remove();
                window.URL.revokeObjectURL(link);
                ApiHandleSuccessMessage(response)
            },
            onError: error => {
                ApiHandleErrorMessage(error)
            }

        })
    }

    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            render: function (text, record) {
                return toFaNumber(text)
            }
        },
        {
            title: 'کاربر',
            dataIndex: 'useracademy_id',
            key: 'useracademy_id',
            render: function (text, record) {
                return (
                    <>

                        <Link className={'app-link'}
                              to={sprintf(URLS.admin.members.edit, {id: record.useracademy_id})}>
                            <div className="flex flex-wrap gap-1">
                                {record?.useracademy?.firstname}
                                <b>{record?.useracademy?.lastname}</b>
                                <span>{record?.useracademy?.mobile}</span>

                            </div>
                        </Link>


                    </>

                )
            }
        },
        {
            title: 'مبلغ',
            dataIndex: 'amount',
            key: 'amount',
            render: function (text, record) {
                return (<>
                    <div className="flex gap-1">
                        {toFaNumberFormat(text)}
                        <span className={'text-gray-400'}>  تومان</span>
                    </div>

                </>)

            }
        },
        {
            title: 'گروه',
            dataIndex: 'id',
            key: 'id_group',
            render: function (text, record) {
                return (
                    <>
                        <RenderIf condition={record?.refund_group_id}>
                            <Link to={sprintf(URLS.admin.refund.group.edit, {id: record?.refund_group_id})}>
                                {record?.refund_group?.title}

                            </Link>
                        </RenderIf>


                    </>

                )
            }
        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            render: function (text, record) {
                return (
                    <>
                        <div className="flex flex-wrap gap-1">
                            <RefundStatusEnumComponent text={text}/>

                        </div>

                    </>

                )
            }
        },

        {
            title: 'تاریخ درخواست',
            dataIndex: 'created_at',
            key: 'created_at',
            render: function (text, record) {
                return formatDateFull(text)
            }
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'edit',
            render: function (text, record) {
                return (<Link to={sprintf(URLS.admin.refund.view, {id: record.id})}>
                    <Button type={'dashed'} size={'small'}>
                        نمایش
                    </Button>
                </Link>)

            }
        },
    ]
    const statusList = [
        {key: '', fa: 'همه',},
        {key: 'pending', fa: 'در انتظار',},
        {key: 'approved', fa: 'تایید شده',},
        {key: 'rejected', fa: 'رد شده',},
        {key: 'cancelled', fa: 'لغو شده',},
        {key: 'payed', fa: 'پرداخت شده',},
    ]


    return (

            <TableSearch
                searchInput={true}
                addButton={<>
                    <div className="flex flex-wrap gap-1 justify-between">
                        <div className="flex flex-wrap gap-1 items-center mx-1">
                            <span className={'text-gray-400 text-xs'}>وضعیت</span>
                            <Select
                                defaultValue={status}
                                value={status}
                                className={'w-32'} onChange={(e) => setStatus(e)}>
                                {statusList.map((item, index) => (
                                    <Select.Option key={item.key + index} value={item.key}>{item.fa}</Select.Option>
                                ))}
                            </Select>
                        </div>
                        <div>
                            <Button
                                loading={isPendingExport}
                                onClick={handleExportExcel}
                                icon={<FileExcelOutlined/>}
                            >دانلود اکسل</Button>
                        </div>
                    </div>


                </>}
                apiFn={refundApi.useAdminSearchRefunds}
                needRefetch={needRefetch}
                fnArgs={{status: status, refund_group_id: refundGroupId}}
                setNeedRefetch={setNeedRefetch}
                columns={columns}/>

    );
}

export default RefundItemsListComponent;